module.exports = __webpack_public_path__ + "img/schedule_edit.358eadd7.svg";